/**
 * Display metadata for the 9-value customer status stored in
 * `sales_actions.sales_status`. Keep this aligned with backend
 * `crates/domain/src/sales_actions/services/proposal_summary.rs`.
 */

import type { SalesStatus } from '@shared/types/sales-action';

export type DisplayStatus = SalesStatus;

export const DISPLAY_STATUS_LABELS: Record<DisplayStatus, string> = {
  no_contact: '未接点',
  contacted: '接点あり',
  in_dialogue: '対話あり',
  appointment: 'アポ予定',
  negotiation_c: '商談/C',
  negotiation_b: '商談/B',
  negotiation_a: '商談/A',
  won: '受注',
  lost: '失注',
};

export const DISPLAY_STATUS_BADGE_CLS: Record<DisplayStatus, string> = {
  no_contact: 'status-no-contact',
  contacted: 'status-contacted',
  in_dialogue: 'status-in-dialogue',
  appointment: 'status-appointment',
  negotiation_c: 'status-negotiation-c',
  negotiation_b: 'status-negotiation-b',
  negotiation_a: 'status-negotiation-a',
  won: 'status-won',
  lost: 'status-lost',
};

export function salesStatusToDisplay(status: SalesStatus): DisplayStatus {
  return status;
}

/**
 * 商談以降 (negotiation_* ・ won ・ lost) は提案ソリューション (product) が必須。
 * backend `SalesStatus::requires_product()` と一致させる。 早期 status
 * (no_contact〜appointment) は商品未定を許容する (C-18)。
 */
export function salesStatusRequiresProduct(status: SalesStatus): boolean {
  return (
    status === 'negotiation_c' ||
    status === 'negotiation_b' ||
    status === 'negotiation_a' ||
    status === 'won' ||
    status === 'lost'
  );
}
